import { api } from "services";
import { toast } from "sonner";

const ReportsView = ({ setReportLoading, type = "pdf" }) => {

  const getFinancialYear = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0 = Jan, 3 = Apr

    // FY starts in April
    return currentMonth >= 3 ? currentYear : currentYear - 1;
  };

  const handleDownload = async (numFY) => {
    setReportLoading((prev) => ({ ...prev, [type]: true }));

    const endMonth = new Date();
    let startMonth;

    if (numFY === "lifetime") {
      startMonth = "lifetime";
    } else {
      const currentFYStart = getFinancialYear();

      startMonth = new Date(currentFYStart - (numFY - 1), 3, 1); // April 1
      startMonth.setHours(0, 0, 0, 0);
    }

    const result = await api.getFYReport(startMonth, endMonth, type);

    setReportLoading((prev) => ({ ...prev, [type]: false }));

    if (result == null) {
      toast.error("Download Failed, Please try again later.");
    }
  };

  const currentFY = getFinancialYear() - 2000;

  return (
    <div className="dropdown">
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(1)}>
            Current FY
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(2)}>
            FY ({currentFY - 1}-{currentFY})
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(3)}>
            FY ({currentFY - 2}-{currentFY - 1})
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload("lifetime")}>
            Lifetime
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ReportsView;